<template>
  <div class="container-fluid">
    <div
      class="d-flex justify-content-center"
      style="width: 100%"
      v-if="loading"
      v-cloak
    >
      <grid-loader
        :loading="loading"
        :color="spinerColor"
        :size="spinerSize"
      ></grid-loader>
    </div>

    <h4
      class="pb-2 mb-2 border-bottom"
      v-if="loading == false && grids.length > 0"
      v-cloak
    >
      {{ $t("my.myGrid") }}
    </h4>
    <div class="jumbotron" v-if="isUnlock == false && grids.length > 0" v-cloak>
      <p class="lead fw-light text-center">{{ $t("my.signTip") }}</p>
    </div>

    <div class="jumbotron" v-if="loading == false && grids.length == 0" v-cloak>
      <p class="lead fw-light text-center" v-html="$t('my.haveNoGrid')"></p>
      <ul class="mt-4 pt-2 list-unstyled border-top">
        <li class="text-muted fw-light">{{ $t("buyTip1") }}</li>
        <li class="text-muted fw-light">{{ $t("buyTip2") }}</li>
      </ul>
    </div>

    <div class="row" v-cloak v-if="isUnlock && grids.length > 0">
      <div class="col mt-2" v-for="(grid, index) in grids" v-bind:key="index">
        <div class="card" style="min-width:18rem">
          <div class="card-body">
            <h6 class="fw-bold">
              #{{ grid.token_id }}
              <span class="badge float-end" :class="statusBadge(grid.status)">{{
                grid.status | gridStatus
              }}</span>
            </h6>
            <div class="card-text">
              <picture-input
                ref="pictureInput"
                :id="grid.token_id"
                @change="onChangePicture"
                :width="150"
                :height="150"
                margin="10"
                accept="image/jpeg,image/png"
                size="1"
                buttonClass="btn"
                :prefill="grid.image_url"
                :customStrings="{
                  upload: $t('my.wrongDevice'),
                  drag: $t('my.uploadPic'),
                  change: $t('my.changePic'),
                  fileSize: $t('my.wrongFileSize'),
                  fileType: $t('my.wrongFileType')
                }"
              >
              </picture-input>

              <form class="mt-3" @submit.prevent="onSubmit(grid)">
                <div class="mb-2">
                  <input
                    type="text"
                    class="form-control"
                    v-model="grid.text"
                    :placeholder="$t('my.textPlaceholder')"
                  />
                </div>
                <div class="mb-2">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="https://"
                    v-model="grid.url"
                  />
                </div>
                <div class="d-grid">
                  <button type="submit" class="btn btn-lg btn-primary">
                    {{ $t("save") }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PictureInput from "vue-picture-input";
import { isURLValid, stringLength } from "../helper.js";

export default {
  mounted() {
    const self = this;
    console.log("MyGridList mounted.");
    this.$eventBus.$on("contracts-ready", function(contract) {
      self.contract = contract;
      // self.getTokens();
      console.log("contracts-ready");
    });

    this.$eventBus.$on("account-changed", function(account) {
      console.log("account-changed ", account);
      self.account = account;
      this.$eventBus.$emit("verify-account", account);
    });

    this.$eventBus.$on("verify-account-success", function(from) {
      self.isUnlock = true;
      self.getTokens();
    });

    this.$eventBus.$on("verify-account-fail", function(from) {
      self.isUnlock = false;
    });
  },
  watch: {
    locale(val) {
      this.$i18n.locale = val;
    }
  },
  data() {
    return {
      locale: "en",
      spinerSize: "8px",
      spinerColor: "#dc3545",
      account: null,
      contract: null,
      loading: false,
      grids: [],
      imageData: "",
      isUnlock: false,
      errors: []
    };
  },
  computed: {},
  components: {
    PictureInput
  },
  methods: {
    onChangePicture(image) {
      console.log("New picture selected!");
      if (image) {
        console.log("Picture loaded.");
        this.imageData = image;
      } else {
        console.log("FileReader API not supported: use the <form>, Luke!");
      }
    },
    onSubmit(grid) {
      // console.log(grid);
      // console.log("Form has been submitted.");

      this.errors = [];
      var isChanged = false;

      if (grid.text != null && grid.text != "") {
        // console.log("text is not empty");
        isChanged = true;
        if (stringLength(grid.text) > 60) {
          this.errors.push("Text is too long");
        }
      }

      if (grid.url != "" && grid.url != null) {
        // console.log("url is not empty");
        isChanged = true;
        if (isURLValid(grid.url) == false) {
          this.errors.push("Please input a valid URL.");
        }
      }
      if (this.errors.length > 0) {
        alert(this.errors.join("\n"));
        return;
      } else if (isChanged) {
        this.errors = [];
        this.save(grid);
      }
    },
    save: function(grid) {
      const self = this;
      const data = {
        text: grid.text,
        url: grid.url,
        image: this.imageData,
        tokenId: grid.token_id,
        id: grid.id,
        owner: grid.owner_address
      };

      this.$http
        .post("/api/grid", data)
        .then(res => {
          // grid.image_url = response.data.image_url;
          // alert(self.$i18n.t("saveSuccess"));
          self.$notify({
            group: "app",
            text: self.$i18n.t("saveSuccess"),
            type: "success"
          });
          // window.location.reload();
        })
        .catch(e => {
          console.error(e);
        });
      return;
    },
    statusBadge: function(status) {
      return {
        "bg-danger": status == "sold",
        "bg-success": status == "normal",
        "bg-warning": status == "pending"
      };
    },
    /**
     * 从合约获取address拥有的token
     */
    async getTokens() {
      const self = this;
      self.loading = true;

      if (this.account == null || this.contract == null) {
        console.log("account or contract is null");
        return false;
      }

      try {
        const tokens = await this.contract.tokensOf(this.account);
        // console.log("tokens", tokens, this.account);
        self.loading = false;
        if (tokens.length > 0) {
          self.getGrids(tokens, self.account);
        }
      } catch (error) {
        // console.error(e);
        self.loading = false;
      }
    },
    /**
     * 获取格子信息
     */
    getGrids: function(tokens, account) {
      if (tokens.length == 0) {
        return false;
      }
      var self = this;
      this.loading = true;
      this.$http
        .get("/api/grids/my", {
          params: {
            ids: tokens.join(","),
            account: account
          }
        })
        .then(response => {
          self.loading = false;
          self.grids = response.data.data;
        })
        .catch(e => {
          console.error(e);
          self.loading = false;
        });
    }
  }
};
</script>
<style>
.image {
  display: block;
  max-width: 200px;
  max-height: 200px;
  width: auto;
  height: auto;
}
</style>
